import React from 'react'
import Mail from '../../Assets/mail.svg'

export default function GetInTouch() {
  return (
    <section className="w-[90%] md:w-[80%] mx-auto pt-8 pb-10 md:pt-10 md:pb-12">
      <div className="grid md:grid-cols-7 my-8 items-center">
        <h2 className="md:col-span-5 text-[36px] md:text-[48px] font-regular flex text-[#fbfbff]">
          <span>
            Let's <br /> Work Together
          </span>
          <span className="rounded w-[20px] h-[4px] rounded bg-white inline-block relative top-[50px] md:top-[85px] ml-5 mt-8 md:mt-6"></span>
        </h2>
        <div className="md:col-span-2 flex flex-col gap-y-2 mt-6 md:mt-0">
          <div className="md:w-[95%] w-full ml-auto flex flex-col gap-3">
            <a
              href="mailto:amirhosen3405@gmail.com"
              target="_blank"
              className="flex gap-2 text-[15px] md:text-[16px] border border-[#1E3A8A] hover:shadow-lg shadow-slate-400 hover:border-slate-500/70 w-full px-3 py-2.5 rounded-md"
            >
              <img
                src={Mail}
                alt=""
                className="w-[24px] md:w-[25px] h-[24px] md:h-[25px] text-white"
              />
              <span>amirhosen3405@gmail.com</span>
            </a>
            {/* Whatsapp */}
            <a
              href="https://wa.me/8801314600405"
              target="_blank"
              className="flex gap-2 text-[14px] border border-[#1E3A8A] hover:shadow-lg shadow-slate-400 hover:border-slate-500/70 w-full px-3 py-2.5 rounded-md bg-[#25d366]"
            >
              {/* <a
              href="https://www.upwork.com/freelancers/~01acfbd2a8074abece"
              target="_blank"
              className="flex gap-2 text-[14px] border border-[#1E3A8A] hover:shadow-lg shadow-slate-400 hover:border-slate-500/70 w-full px-3 py-2 rounded-md bg-[#25d366]"
            > */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="w-[25px] md:w-[26px] h-[24px] md:h-[25px] "
              >
                <path
                  fill="currentColor"
                  d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                />
              </svg>
              {/* <img
                src="https://img.icons8.com/?size=100&id=fF39hkEhFlir&format=png&color=ffffff"
                alt=""
                className="w-5 h-5 text-white"
              /> */}
              <span className="text-[15px] md:text-[16px]">
                Lets chat on WhatsApp
              </span>
            </a>
            {/* Discord */}
            <a
              href="https://discord.com/users/913338036673191946"
              target="_blank"
              className="flex gap-2 text-[14px] border border-[#1E3A8A] hover:shadow-lg shadow-slate-400 hover:border-slate-500/70 px-3 py-2.5 rounded-md bg-[#5865f2]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
                className="w-[24px] md:w-[25px] h-[24px] md:h-[25px] "
              >
                <path
                  fill="currentColor"
                  d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4a.1.1 0 0 0-.07.03c-.18.33-.39.76-.53 1.09a16.1 16.1 0 0 0-4.8 0c-.14-.34-.35-.76-.54-1.09c-.01-.02-.04-.03-.07-.03c-1.5.26-2.93.71-4.27 1.33c-.01 0-.02.01-.03.02c-2.72 4.07-3.47 8.03-3.1 11.95c0 .02.01.04.03.05c1.8 1.32 3.53 2.12 5.24 2.65c.03.01.06 0 .07-.02c.4-.55.76-1.13 1.07-1.74c.02-.04 0-.08-.04-.09c-.57-.22-1.11-.48-1.64-.78c-.04-.02-.04-.08-.01-.11c.11-.08.22-.17.33-.25c.02-.02.05-.02.07-.01c3.44 1.57 7.15 1.57 10.55 0c.02-.01.05-.01.07.01c.11.09.22.17.33.26c.04.03.04.09-.01.11c-.52.31-1.07.56-1.64.78c-.04.01-.05.06-.04.09c.32.61.68 1.19 1.07 1.74c.03.01.06.02.09.01c1.72-.53 3.45-1.33 5.25-2.65c.02-.01.03-.03.03-.05c.44-4.53-.73-8.46-3.1-11.95c-.01-.01-.02-.02-.04-.02M8.52 14.91c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.84 2.12-1.89 2.12m6.97 0c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.83 2.12-1.89 2.12"
                />
              </svg>
              {/* <img
                src="https://img.icons8.com/?size=100&id=e2Av13lVqNpr&format=png&color=FFFFFF"
                alt=""
                className="w-6 h-6 text-white"
              /> */}
              <span className="text-[15px] md:text-[16px]">
                DM me on Discord
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
